import { useEffect, useState } from 'react';

export const useDocumentVisible = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const visibilitychange = () => {
      if (document.visibilityState === 'visible') {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    document.addEventListener('visibilitychange', visibilitychange);

    return () => {
      document.removeEventListener('visibilitychange', visibilitychange);
    };
  }, []);

  return visible;
};
